import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion"
import styled from "styled-components"

import { theme } from "Theme"
import { BrandedColor } from "Styles"

const Wrapper = styled.section`
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 !important;
  padding: 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }

  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: column;
    width: 100%;
    padding: 2rem;
  }

  @media (min-width: ${theme.breakpoints.l}) {
  }
  max-width: ${theme.layout.base};
`

const Content = styled.div`
  display: block;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  background-color: ${(props) => (props.dark ? theme.colors.black.base : theme.colors.white.base)};
  color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  border-color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Title = styled.h2`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`
const Subtitle = styled.p`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin: 0 auto;
  & + a {
    margin-top: 1rem;
  }
  text-align: center;
`

const StyledAccordion = styled(Accordion)`
  &:hover {
    cursor: pointer;
  }

  .faq {
    border-bottom: 2px solid #ccc;
    padding: 4px;
    outline: none;
    cursor: pointer;
    display: grid;
    grid-template-columns: 100px 1fr;
    align-items: center;
    margin: 0;
  }

  .faq-title {
    border: none;
    background: none;
    padding: 0;
    outline: none;
    width: 100%;
    text-align: left;
    cursor: pointer;
    font-weight: bold;
    padding: 24px;
    padding-right: 72px;
    padding-left: 16px;
    position: relative;

    &::after {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      border-left: 2px solid #000;
      border-bottom: 2px solid #000;
      position: absolute;
      top: 34px;
      right: 36px;
      transform: rotate(-45deg);
      transition: transform 0.3s ease-in-out;
    }

    &.active {
      &::after {
        transform: rotate(135deg);
      }
    }
  }

  .faq-content {
    padding: 0 72px 32px 16px;
    line-height: 26px;
    color: #ccc;
  }
`

const ScheduleButton = styled(AccordionItemButton)`
  position: relative;
  padding: 4px;
  outline: none;
  cursor: pointer;
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
  margin: 0;
  :after {
    content: "►";
    position: absolute;
    right: 0;
    padding: 0 1rem;
  }
  &[aria-expanded="true"] {
    color: ${theme.colors.primary.base};
    background: ${theme.colors.white.base};
    border-radius: ${theme.borderRadius.ui};
    border-color: ${theme.colors.primary.base};
    outline: 0;
    border-bottom: 1px solid #000;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    :after {
      color: ${theme.colors.black.base};
      content: "▲";
    }
  }
`

const AccordionTime = styled.div`
  color: inherit;
  border-right: 1px solid #aaa;
  margin: 0;
  margin-right: 8px;
  text-align: left;
  font-size: ${theme.fontSize.small};
`

const AccordionFromTime = styled.p`
  color: inherit;
  max-width: ${theme.layout.base};
  margin: 0 auto;
  & + a {
    margin-top: 1rem;
  }
  text-align: center;
`

const AccordionToTime = styled.p`
  color: inherit;
  max-width: ${theme.layout.base};
  margin: 0 auto;
  & + a {
    margin-top: 1rem;
  }
  text-align: center;
`

const AccordionTitle = styled.p`
  color: inherit;
  font-weight: bold;
  text-align: left;
  margin: 0;
`

const Agenda = ({
  title,
  schedule,

  subtitle,

  children,
}) => (
  <>
    <Wrapper>
      <Content>
        {/* <Zoom duration={600} delay={500}> */}
        <>
          <Title>
            The <BrandedColor>{title}</BrandedColor>
          </Title>
          <Subtitle>{subtitle}</Subtitle>
          {children && children}
        </>
        {/* </Zoom> */}

        <StyledAccordion>
          {schedule.map((item, i) => (
            <div key={i}>
              {/* <Fade delay={i * 200}> */}
              <AccordionItem uuid={`${item.agendaId}`}>
                <AccordionItemHeading>
                  <ScheduleButton>
                    <AccordionTime>
                      <AccordionFromTime>{`${item.startTime}`}</AccordionFromTime>
                      <AccordionToTime>{`${item.endTime}`}</AccordionToTime>
                    </AccordionTime>
                    <AccordionTitle>{`${item.agendaTitle}`}</AccordionTitle>
                  </ScheduleButton>
                </AccordionItemHeading>
                <AccordionItemPanel>{`${item.description}`}</AccordionItemPanel>
              </AccordionItem>
              {/* </Fade> */}
            </div>
            // <Collapsible
            //   key={i}
            //   className="faq"
            //   openedClassName="faq active"
            //   triggerClassName="faq-title"
            //   triggerOpenedClassName="faq-title active"
            //   triggerTagName="button"
            //   contentInnerClassName="faq-content"
            //   trigger={title}
            //   transitionTime={300}
            //   easing="ease-out">
            //   {`${item.agendaTitle}`}
            // </Collapsible>

            //  <Collapsible
            //     key={i}
            //     className="faq"
            //     openedClassName="faq active"
            //     triggerClassName="faq-title"
            //     triggerOpenedClassName="faq-title active"
            //     triggerTagName="button"
            //     contentInnerClassName="faq-content"
            //     trigger={`${item.startTime} - ${item.startTime}`}
            //     transitionTime={300}
            //     easing="ease-out">
            //     <AccordionTime>
            //       <AccordionFromTime>{`${item.startTime}`}</AccordionFromTime>
            //       <AccordionToTime>{`${item.endTime}`}</AccordionToTime>
            //     </AccordionTime>
            //     <AccordionTitle>{`${item.agendaTitle}`}</AccordionTitle>
            //   </Collapsible>
          ))}
        </StyledAccordion>
      </Content>
    </Wrapper>
  </>
)

export default Agenda
